import styled from "styled-components";
import AboutSection from "../about/components/AboutSection";
import ExpertiseSection from "../about/components/ExpertiseSection";
import ProgressSection from "../about/components/ProgressSection";
import ServiceSection from "../service/components/ServiceSection";
import HeroSection from "./components/HeroSection";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

function HomePage() {
  return (
    <Wrapper>
      <HeroSection />
      <ServiceSection showViewAction />
      <AboutSection />
      <ExpertiseSection />
      <ProgressSection />
    </Wrapper>
  );
}

export default HomePage;
